module.exports = __webpack_public_path__ + "media/images/pc/stores/kyoto/kyoto_concept_02-c3403a94291f7ad977a3abf71fa331bf.jpg";